import { useDialog } from '@wui/common-library'

import { ConfirmDialog } from '../ui'

export const useConfirmDialog = () => {
  const { showDialog } = useDialog<boolean>()
  const show = async (props: {
    title: string
    message: string
    confirmLabel?: string
    cancelLabel?: string
  }) => {
    return await showDialog(ConfirmDialog, {
      title: props.title,
      message: props.message,
      ...(props.confirmLabel ? { confirmLabel: props.confirmLabel } : {}),
      ...(props.cancelLabel ? { cancelLabel: props.cancelLabel } : {}),
      hasOverlay: true,
    })
  }

  return {
    show,
  }
}
